import Styled, { css } from "styled-components";
import { screenSize } from "../../constant";
import { ITheme, TBrowserAppType } from "../../interface";
import { useTheme } from "../../context/ThemeProvider";
import IkbalPhoto from "../../assets/images/IkbalPhoto.png";

const { maxWidth } = screenSize;

const ImageContainer = Styled.div<{ $props: { showContent: boolean } }>`
  z-index: 2;
  position: relative;
`;

const ImageWrapper = Styled.div<{
  $props: { showContent: boolean; browserType: TBrowserAppType };
}>`
  transition: all 0.5s ease-in-out 0s;
  position: absolute;
  
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  margin: 0vh 0vw 0vh -10vw;

  ${({ $props }) => {
    const { showContent, browserType } = $props;
    const opacity = showContent ? 1 : 0;
    const translateXValue = showContent ? 0 : 100;
    const translateYValue = browserType === 'chrome' ? 0 : -12;

    return css`
      opacity: ${opacity};
      transform: translate(${translateXValue}%, ${translateYValue}%);
      @media screen and (max-width: ${maxWidth.mediumTablet}) {
        margin: 0;
        top: 70%;
        left: -50%;
        height: 25%;
        width: 70%;
        transform: translate(22%, -${translateXValue * 2 + 110}%);
      }
      @media screen and (max-width: ${maxWidth.mediumPhoneV2}) {
        transform: translate(22%, -${translateXValue * 1 + 70}%);
        top: 57%;
      }
      @media screen and (max-width: ${maxWidth.smallPhoneV1}) {
        top: 55%;
      }
    `;
  }}
`;

const ImageBoxResponsiveness = css`
  @media screen and (max-width: ${maxWidth.mediumTablet}) {
    width: 25vw;
  }
  @media screen and (max-width: ${maxWidth.mediumPhoneV4}) {
    width: 30vw;
  }
  @media screen and (max-width: ${maxWidth.mediumPhoneV1}) {
    width: 35vw;
  }
  @media screen and (max-width: ${maxWidth.smallPhoneV3}) {
    width: 42vw;
  }
  @media screen and (max-width: ${maxWidth.smallPhoneV1}) {
    width: 65vw;
  }
`;

const ImageBox = Styled.div`
  transition: all 0.4s ease-in-out 0s;
  position: absolute;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  > * {
    visibility: visible;
  }
  &:before {
    content: "";
    padding-top: 86.6%;
    background: currentColor;
  }
  ${ImageBoxResponsiveness}
`;

const ImageBoxBunshin = Styled.div<{ $props: ITheme }>`
  ${({ $props }) => {
    return css`
      color: ${$props.colors.primary};
      filter: url(#round)
        drop-shadow(${$props.colors.quarternary} 0px 7.5px 5px);
    `;
  }}
  position: absolute;
  transition: all 0.4s ease-in-out 0s;
  width: 90%;
  &:before {
    content: "";
    display: block;
    width: 100%;
    padding-top: 86.6%;
    background: currentColor;
    clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
    transform: rotate(90deg);
  }
  ${ImageBoxResponsiveness}
`;
const CoverImage = Styled.img`
    max-width: 100%;
    max-height: 145%;
    z-index: 1;
    position: absolute;
    clip-path: polygon(0% 0%, 100% 0%, 100% 82.5%, 50% 100%, 0% 82.5%);
    top: -37.4%;
`;

function LandingIkbalPhoto({ showContent }: { showContent: boolean }) {
  const { oppositeTheme, browserType } = useTheme();
  return (
    <ImageContainer $props={{ showContent }}>
      <ImageWrapper $props={{ showContent, browserType }}>
        <ImageBox>
          <CoverImage src={IkbalPhoto} />
        </ImageBox>
        <ImageBoxBunshin $props={oppositeTheme} />
      </ImageWrapper>
    </ImageContainer>
  );
}

export default LandingIkbalPhoto;
